import { FeatureFlag } from "us.common/FeatureFlagContext/Interfaces";

export enum FeatureFlags {
  MERGE_DEBTOR = "MergeDebtor",
  NON_PRODUCTION_DAYS = "NonProductionDays",
  OPERATIONS = "OperationsModule",
  FILE_CONVERTER = "FileConverter",
  UNIQ_ASSISTANT = "UniQAssistant",
  POWER_BI_DASHBOARD = "PowerBIDashboard",
}

export const DEFAULT_FEATURE_FLAGS: Array<FeatureFlag> = [
  {
    featureName: FeatureFlags.MERGE_DEBTOR,
    isEnabled: false,
  },
  {
    featureName: FeatureFlags.NON_PRODUCTION_DAYS,
    isEnabled: false,
  },
  {
    featureName: FeatureFlags.OPERATIONS,
    isEnabled: false,
  },
  {
    featureName: FeatureFlags.FILE_CONVERTER,
    isEnabled: false,
  },
  {
    featureName: FeatureFlags.UNIQ_ASSISTANT,
    isEnabled: false,
  },
  {
    featureName: FeatureFlags.POWER_BI_DASHBOARD,
    isEnabled: false,
  },
  {
    featureName: FeatureFlags.FILE_CONVERTER,
    isEnabled: false,
  },
];
